var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2008_717)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66683 1.83301C4.44517 1.83301 1.8335 4.44468 1.8335 7.66634C1.8335 10.888 4.44517 13.4997 7.66683 13.4997C10.8885 13.4997 13.5002 10.888 13.5002 7.66634C13.5002 4.44468 10.8885 1.83301 7.66683 1.83301ZM0.833496 7.66634C0.833496 3.8924 3.89288 0.833008 7.66683 0.833008C11.4408 0.833008 14.5002 3.8924 14.5002 7.66634C14.5002 9.37335 13.8742 10.9342 12.8394 12.1318L15.0204 14.3128C15.2156 14.5081 15.2156 14.8246 15.0204 15.0199C14.8251 15.2152 14.5085 15.2152 14.3133 15.0199L12.1323 12.8389C10.9347 13.8738 9.37384 14.4997 7.66683 14.4997C3.89288 14.4997 0.833496 11.4403 0.833496 7.66634Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2008_717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.0d7b30468649926c46646e4eedc6801d.svg";
export { ForwardRef as ReactComponent };